
import { Component, Prop, Vue } from "vue-property-decorator";
import GuestsTab from "@/components/GuestsTab.vue";

@Component({
  components: { GuestsTab },
})

export default class NonTransferableGuestsTab extends Vue {

  @Prop({ default: null })
  public nonTransferableId: number;

  private mounted() {
    setTimeout(() => {
      this.$emit("loaded");
    }, 500);
  }
}
